/**
 * A list of names as one cell: how many, and which.
 *
 * The count first, because that is what is being verified — the names are there to explain it.
 *
 * @param names - What was found.
 * @param empty - What to show when nothing was.
 */
export function describeCount(names: string[], empty = ""): string {
  return names.length > 0 ? `${names.length} (${names.join(", ")})` : empty;
}
